import axios from "axios";

let logoutHandler: (() => void) | null = null;

export const setLogoutHandler = (handler: () => void) => {
  logoutHandler = handler;
};

const api = axios.create({
  //baseURL: "http://localhost:8092/web/v1", // cambiar en producción
  baseURL: "https://woxti.com/web/v1",
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // necesario para enviar cookies HttpOnly
});

// Añadir access token desde localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Manejo global de errores + refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si 401 y no hemos reintentado
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Llamada al backend para refresh token usando cookie HttpOnly
        const res = await api.post("/refresh");
        const newToken = res.data.token;

        localStorage.setItem("token", newToken);
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        // Reintentar la request original
        return await api(originalRequest);
      } catch (refreshError) {
        if (logoutHandler) logoutHandler();
        else window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    // Logout si 403 o refresh falló
    if (error.response?.status === 403) {
      if (logoutHandler) logoutHandler();
      else window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;
